import { localQueryKey } from "hooks/useTypedQuery";

import type { ExportEvent } from "models";

export type AppNotification = {
  id: string;
  icon: string;
  time: string;
  title: string;
  description: string;
  appointmentId?: number;
  exportEvent?: ExportEvent;
  onClick: () => void;
};

const component = "NotificationsCenter";

export const NotificationsCenterQueryKeys = {
  notifications: localQueryKey<AppNotification[]>({ component, data: "notifications" }),
  isNotificationsCenterOpen: localQueryKey<boolean>({ component, data: "isNotificationsCenterOpen" })
};
